module.exports = __webpack_public_path__ + "img/progress.d8542df1.png";